import { render, staticRenderFns } from "./PageEducatorInstitutionStudentEdit.vue?vue&type=template&id=351acbc2&scoped=true&"
import script from "./PageEducatorInstitutionStudentEdit.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionStudentEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionStudentEdit.vue?vue&type=style&index=0&id=351acbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351acbc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VRow})
